module.exports = __webpack_public_path__ + "media/application/images/demsoc/tiles/polychrome_3-e902d80bd425281613eed236abe4877b.jpg";